import { ReactComponent as LeftButton } from '../../assets/svg/left-button.svg';
import { ReactComponent as ChevronRight } from '../../assets/svg/chevron-right.svg';
import { ReactComponent as Close } from '../../assets/svg/close.svg';
import { ReactComponent as Setting } from '../../assets/svg/setting.svg';
import { ReactComponent as AppLogo } from '../../assets/svg/app-logo.svg';
import { ReactComponent as AppLogoW } from '../../assets/svg/app-logo-w.svg';
import { ReactComponent as DotActive } from '../../assets/svg/dot-active.svg';
import { ReactComponent as DotEmpty } from '../../assets/svg/dot-empty.svg';
import { ReactComponent as DotFill } from '../../assets/svg/dot-fill.svg';
import { ReactComponent as DotWrong } from '../../assets/svg/dot-wrong.svg';
import { ReactComponent as Backspace } from '../../assets/svg/backspace.svg';
import { ReactComponent as StarYellow } from '../../assets/svg/star-yellow.svg';
import { ReactComponent as BGLineWhite } from '../../assets/svg/bg-line-white.svg';
import { ReactComponent as BGLinePrimary } from '../../assets/svg/bg-line-primary.svg';
import { ReactComponent as BGLinePrimaryWithPeoples } from '../../assets/svg/bg-line-primary-with-peoples.svg';



function setAttributes (props) {
  const result = { ...props };
  if (result?.size) {
      result.height = props.size;
      result.width = props.size;
      delete result.size;
  }
  return result;
};

export const MLeftButton = (props) => <LeftButton {...setAttributes(props)} />
export const MChevronRight = (props) => <ChevronRight {...setAttributes(props)} />
export const MClose = (props) => <Close {...setAttributes(props)} />
export const MSetting = (props) => <Setting {...setAttributes(props)} />
export const MAppLogo = (props) => <AppLogo {...setAttributes(props)} />
export const MAppLogoW = (props) => <AppLogoW {...setAttributes(props)} />
export const MDotActive = (props) => <DotActive {...setAttributes(props)} />
export const MDotEmpty = (props) => <DotEmpty {...setAttributes(props)} />
export const MDotFill = (props) => <DotFill {...setAttributes(props)} />
export const MDotWrong = (props) => <DotWrong {...setAttributes(props)} />
export const MBackspace = (props) => <Backspace {...setAttributes(props)} />
export const MStarYellow = (props) => <StarYellow {...setAttributes(props)} />
export const MBGLineWhite = (props) => <BGLineWhite {...setAttributes(props)} />
export const MBGLinePrimary = (props) => <BGLinePrimary {...setAttributes(props)} />
export const MBGLinePrimaryWithPeoples = (props) => <BGLinePrimaryWithPeoples {...setAttributes(props)} />
